<script setup lang="ts">
import { MediaRemoteVideo } from '~/api/graphql/generated'

const props = defineProps<{
  entity: MediaRemoteVideo | undefined
}>()
const emits = defineEmits<{
  (e: 'clickedMedia', value: { entity: MediaRemoteVideo | undefined }): void
}>()
const mediaButtonClickHandler = (event: MouseEvent) => {
  event.stopPropagation()
  emits('clickedMedia', { entity: props.entity })
}

const imageUrl = props.entity?.fieldPreviewImage?.url || ''
</script>

<template>
  <div class="counter-container">
    <div class="counter">
      <div
        class="counter-thumbnail"
        :style="{
          backgroundImage: `url('${imageUrl}')`,
        }"
      >
        <Icon name="media-play" class="media-button" @click="mediaButtonClickHandler($event)" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.counter-container {
  background-color: rgba(24, 36, 111, 0.08);
  width: 210px;
  height: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  z-index: 4;
  transition:
    width 0.3s ease-in,
    height 0.3s ease-in;
  .counter {
    background-color: #fff;

    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition:
      width 0.3s ease-in,
      height 0.3s ease-in;
    .counter-thumbnail {
      width: 210px;
      height: 210px;
      background-size: cover;
      background-position: center;
      position: absolute;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition:
        width 0.3s ease-in,
        height 0.3s ease-in;
      .media-button {
        height: 40px;
        width: 40px;
        color: #fff;
        background: var(--c-blue-100);
        border-radius: 50%;
        cursor: pointer;
      }
    }
  }
  @include breakpoint(tl) {
    :hover > & {
      width: 274px;
      height: 274px;
      background-color: rgba(24, 36, 111, 0.08);
      transition:
        width 0.3s ease-in,
        height 0.3s ease-in;
      .counter {
        .counter-thumbnail {
          width: 230px;
          height: 230px;
          transition:
            width 0.3s ease-in,
            height 0.3s ease-in;
        }
      }
    }
  }
}
</style>
